import Model, { attr, belongsTo } from '@ember-data/model';

export default class PlaylistEntryModel extends Model {
  @attr('number') order;

  @belongsTo('playlist', { inverse: null, async: false }) playlist;
  @belongsTo('project', { inverse: null, async: false }) project;
  @belongsTo('bounce', { inverse: null, async: false }) bounce;
}
